import {observer} from 'mobx-react-lite'
import React from 'react'

import {useMainMenuStore} from '../main-menu-store'

import {Lang} from 'yougile-lang'

import {MenuIconButtonPage} from '../components/menu-icon-button-page'
import {MenuButtonPage} from '../components/menu-button-page'
import {billingPage} from '../constants'

export const BillingMenuItem = observer(() => {
  const [state] = useMainMenuStore()
  const {paymentStatus, showBilling, readonly, canSeeLicensesPage} = state

  const canSeeFeedback = !(
    paymentStatus && paymentStatus.tariff === 'standalone'
  )
  const canSeeBilling =
    showBilling && canSeeLicensesPage && !readonly && canSeeFeedback

  if (!canSeeBilling) {
    return null
  }

  if (state.menuOpen) {
    const text = Lang.msg.menu.billingHint

    return (
      <MenuButtonPage page={billingPage} text={text} icon={'IconLicense'} />
    )
  }

  return (
    <MenuIconButtonPage
      icon="IconLicense"
      page={billingPage}
      hint={Lang.msg.menu.billingHint}
    />
  )
})
